<template>
    <div>
      <!-- modal -->
      <b-modal id="lawSubjectFormModal" ref="lawSubjectFormModal" centered size="lg" no-close-on-backdrop :title=" $t('lawSubject.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
          <b-row>
            <b-col class="col-lg-12">
              <b-form>
                  <label for="law-subject-name-input">{{ $t('lawSubject.name') }}</label>
                  <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('lawSubject.name')" rules="required" >
                      <b-form-input id="law-subject-name-input" size="sm" v-model="name" maxlength="50" :state="errors.length > 0 ? false:null"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-lg-8">
              <b-form>
                  <label for="law-subject-case-type-input">{{ $t('matter.matter_case_type') }}</label>
                  <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('matter.matter_case_type')" :rules="isLawMatterCaseTypeLocked ? { excluded:0 } : ''" >
                      <b-form-select id="law-subject-case-type-input" size="sm" v-model="lawMatterCaseTypeSelect" value-field="id" text-field="name" :options="lawMatterCaseTypeOption" :state="errors.length > 0 ? false:null"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
              </b-form>
            </b-col>
            <b-col class="col-lg-4">
              <label for="law-subject-case-type-locked-input">{{ $t('lawSubject.case_type_locked') }}</label>
              <br>
              <b-form-checkbox class="custom-control-success" name="law-subject-case-type-locked-input" id="law-subject-case-type-locked-input" v-model="isLawMatterCaseTypeLocked" switch>
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </b-col>
          </b-row>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
      getLawSubjectList: {type: Function},
    },
    data() {
      return {
        id: 0,
        name: '',
        lawMatterCaseTypeSelect: 0,
        lawMatterCaseTypeOption: [],
        isLawMatterCaseTypeLocked: false
      }
    },
    methods: {
      showInfo(id) {  
        this.$refs['lawSubjectFormModal'].show()
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'LawSubject'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.name = response.data.lawSubject.name
                this.lawMatterCaseTypeSelect = response.data.lawSubject.lawMatterCaseTypeId || 0
                this.isLawMatterCaseTypeLocked = response.data.lawSubject.isLawMatterCaseTypeLocked
                this.lawMatterCaseTypeOption = response.data.lawMatterCaseTypeList
                this.lawMatterCaseTypeOption.splice(0, 0, this.$nullSelected())
            } else {
                this.$bvModal.hide('lawSubjectFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, name: this.name, lawMatterCaseTypeId: this.lawMatterCaseTypeSelect || null, isLawMatterCaseTypeLocked: this.isLawMatterCaseTypeLocked}
        const controller = {name : 'LawSubject'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$store.dispatch('moduleAuth/save',payload).then((response) => {
              if(response.data.resultStatus == true){
                  this.$bvModal.hide('lawSubjectFormModal')
                  this.getLawSubjectList()
                  this.$SaveAlert()
              } else {
                  this.$WarningAlert(response.data.resultMessage)
              }
            })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  